import { useMemo } from "react"
import { TableCell, TableRow, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Bound } from "lib/@components/binding/Bound"
import { ComparisonFacilityBreakdownCell } from "./comparison-facility-breakdown-cell"

export function ComparisonFacilityBreakdownRow({ facilityName }) {
    const { variants } = useBoundContext()
    const lowestCost = useMemo(getLowestCost, [facilityName, variants])

    return (
        <TableRow data-cy="comparison-facility-row">
            <TableCell>
                <Typography variant="body2">{facilityName}</Typography>
            </TableCell>
            <Bound facilityName={facilityName} lowestCost={lowestCost}>
                <Repeat list={variants} item={<ComparisonFacilityBreakdownCell />} />
            </Bound>
        </TableRow>
    )

    function getLowestCost() {
        let min = Infinity
        let count = 0
        for (const v of variants) {
            const facility = (v?.costResult?.facilityBreakdown ?? []).find(matchesFacility)
            if (!facility) continue
            if (facility.totalCost < min) {
                min = facility.totalCost
                count = 1
            } else if (facility.totalCost === min) {
                count++
            }
        }
        if (min === Infinity) return null
        if (count > 1) return null
        return min
    }

    function matchesFacility(f) {
        return f.facilityName === facilityName
    }
}
